const getPaymentContainerColumns = ({ actionCell }: { actionCell: (_params: any) => React.ReactNode }) => {
  return [
    {
      field: "containerNos",
      headerName: "Container Nos",
      flex: 1
    },
    {
      field: "truck",
      headerName: "Truck",
      flex: 1
    },

    {
      field: "gd",
      headerName: "GD",
      flex: 1
    },
    {
      field: "cnee.name",
      headerName: "Consignee",
      flex: 1
    },
    {
      field: "term",
      headerName: "Term",
      flex: 1
    },
    {
      field: "action",
      headerName: "Action",
      width: 75,
      renderCell: actionCell
    }
  ]
}

export { getPaymentContainerColumns }
